import React, { useState, useEffect, useCallback } from 'react';
import Leaderboard from './Leaderboard';
import ClickerPage from './ClickerPage';
import Purchase from './Purchase';
import Quests from './Quests';
import ProfilePage from './ProfilePage';
import AchievementsPage from './AchievementsPage';
import ReferralPage from './ReferralPage';
import Friends from './Friends';
import FriendsInv from './Friends_inv';
import Soon from './soon';
import Refbord from './ref_lead';
import Clans from './Clans';
import ClanCreate from './clans_add';
import ClanList from './Clans_list';
import ClanInfo from './clans_info';
import Boss from './boss';
import ClanWarsPage from './ClanWarsPage';
import StartupScreen from './components/StartupScreen';
import AppShell from './components/AppShell';
import useImagePreloader from './hooks/useImagePreloader';
import { FALLBACK_AVATAR_URL, PRELOAD_IMAGE_URLS, ROBLOX_TIPS } from './app/constants';
import { fetchWithTimeout, formatCompactNumber } from './app/utils';

import './App.css';

function App() {
const [tag, setTag] = useState(null); // Для хранения тега клана
const [leaderboardData, setLeaderboardData] = useState([]);
const [isVideoLoaded, setIsVideoLoaded] = useState(false);
const [availableQuests, setAvailableQuests] = useState([]);
const [completedQuests, setCompletedQuests] = useState([]);
const [achievements, setAchievements] = useState([]);
const [userAchievements, setUserAchievements] = useState([]);
const [leaderboard, setLeaderboard] = useState({});
const [rankData, setRankData] = useState([]);
  const [currentPage, setCurrentPage] = useState('clicker');
  const [username, setUsername] = useState(''); 
  const [clickCount, setClickCount] = useState(0);
  const [user_clan_id, setUserClanID] = useState(null);
  const [energy, setEnergy] = useState(0);
  const [maxEnergy, setMaxEnergy] = useState(0);
  const [income, setIncome] = useState(0);
  const [rewards, setRewards] = useState(0);
  const [inventory, setInventory] = useState([]); // Инвентарь
  const [rank, setRank] = useState(null); 
  const [rankProgress, setRankProgress] = useState(0);
  const [clickPower, setClickPower] = useState(1);
  const [userID, setUserID] = useState(1);  
  const [refs, setRefs] = useState(1);
  const [refss, setRefss] = useState(1);
  const [clan, setClan] = useState(null);
  const [robux_balance, setRobuxBalance] = useState(null);
  const [energy_charge, setEnergyCharge]  = useState(0);
  const [referralCode, setReferralCode] = useState(1);  
  const [totalClicksPerHour, setTotalClicksPerHour] = useState(0);
  const [avatarUrl, setAvatarUrl] = useState(''); 
  const [realuserID, setrealUserID] = useState(false); 
    const [effectsEnabled, setEffectsEnabled] = useState(true);
    const [cards, setCards] = useState([]);
    const [toastMessage, setToastMessage] = useState(null);
    const [showToast, setShowToast] = useState(false);
    const [maxClicks, setMaxClicks] = useState({});
    const [selectedClan, setSelectedClan] = useState(null);  // Хранение данных выбранного клана
    const [notifications, setNotifications] = useState([]);
    const [isLoadingData, setIsLoadingData] = useState(true);  // Флаг загрузки
     const [isLoadingAva, setIsLoadingAva] = useState(true);  // Флаг загрузки
     const [startupError, setStartupError] = useState('');
    const [TotalClickBonus, setTotalClickBonus] = useState(0);  // Флаг загрузки
    const [robloxusername, setRobloxUsername] = useState('');  // Флаг загрузки
const [ranks, setRanks] = useState([]);
const { isLoading, progress } = useImagePreloader(PRELOAD_IMAGE_URLS);
const randomTip = useState(() => ROBLOX_TIPS[Math.floor(Math.random() * ROBLOX_TIPS.length)])[0];



useEffect(() => {
  const video = document.createElement("video");
  video.src = "/кто.mp4";
  video.preload = "auto";

  // Устанавливаем флаг, что видео загружено
  video.onloadeddata = () => {
    setIsVideoLoaded(true);
  };

  // Если произошла ошибка при загрузке видео, показываем заглушку
  video.onerror = () => {
    console.error("Ошибка загрузки видео");
    setIsVideoLoaded(false); // В случае ошибки показываем заглушку
  };
}, []);
  const fetchAllCards = useCallback(async () => {
      if (!username) return;
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/cards/${username}`);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const data = await response.json();
        const nextCards = Array.isArray(data.cards) ? data.cards : [];
        setCards(nextCards);

        // Warm the browser cache as soon as the app starts. The store can then
        // reveal cards instantly instead of downloading them on first visit.
        nextCards.forEach((card) => {
          const image = new Image();
          image.src = card.img?.startsWith('/') ? card.img : `/cards/${card.img}.png`;
        });

        const total = nextCards.reduce((acc, card) => {
          return acc + (card.unlocked ? (Number(card.base_clicks_per_hour) * (Number(card.level) || 0)) : 0);
        }, 0);
  
        setTotalClicksPerHour(total);
      } catch (err) {
        console.error('Ошибка при загрузке карточек:', err.message);
      }
  }, [username]);

  useEffect(() => {
    fetchAllCards();
  }, [fetchAllCards]);
    
  const fetchRanks = useCallback(async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/leaderboard/ranks`);
      if (!response.ok) {
        throw new Error('Ошибка сети');
      }
      const ranksData = await response.json();
      // Преобразуем данные в объект maxClicks
      const maxClicksData = {};
      ranksData.forEach(rank => {
        maxClicksData[rank.name] = rank.max_clicks; // предполагаем, что у вас есть свойства name и max_clicks
      });
  
      // Обновляем состояния
      setMaxClicks(maxClicksData);
      setRanks(ranksData);
    } catch (error) {
      console.error('Ошибка получения данных о рангам:', error);
    }
  }, []);
useEffect(() => {
  fetchRanks();
}, [fetchRanks]);


// Обновляем getRank с использованием maxClicks
const getRank = useCallback((count) => {
  if (!ranks.length) return null;
  const matchingRank = ranks.find((item) => Number(count) <= Number(item.max_clicks));
  return (matchingRank || ranks[ranks.length - 1]).name;
}, [ranks]);
useEffect(() => {
    if (!isLoading && rank) {  // Проверка загрузки и валидности rank
      // Запрос на сервер для обновления click_count у рефералов
      fetch(`${process.env.REACT_APP_API_URL}/leaderboard/update-referrals`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, currentRank: rank }),
      })
        .then(response => response.json())
        .then(data => {
          if (data.message) {
            console.log(data.message);
          }
        })
        .catch(error => console.error('Ошибка при обновлении рефералов:', error));
    }
  }, [isLoading, rank, username]);




  const fetchUserData = useCallback(async (targetUsername) => {
    try {
      const response = await fetchWithTimeout(`${process.env.REACT_APP_API_URL}/users/${targetUsername}`, { cache: 'no-store' });
      if (!response.ok) {
        const details = await response.json().catch(() => ({}));
        throw new Error(`HTTP ${response.status}: ${details.error || details.message || 'ошибка профиля'}`);
      }
      const data = await response.json();
      setClickCount(Number(data.click_count) || 0);
      setEnergy(Number(data.energy) || 0);
      setEnergyCharge(Number(data.energy_charges) || 0);
      setMaxEnergy(Number(data.max_energy) || 0);
      setIncome(Number(data.income_per_hourr) || 0);
      setrealUserID(data.id);
      setClickPower(Number(data.click_power) || 1);
      setRefs(Number(data.refs) || 0);
      setUserClanID(data.clan_id);
      setRobuxBalance(data.robux_balance);
      setRobloxUsername(data.roblox_username);
      setReferralCode(data.referral_code);
      if (data.avatar_url) setAvatarUrl(data.avatar_url);
      setIsLoadingData(false);
    } catch (error) {
      console.error('Ошибка:', error);
      setStartupError(`Не удалось загрузить профиль (${error.message}). Закройте приложение и снова откройте его через Telegram.`);
    } finally {
      setIsLoadingData(false);
    }
  }, []);

  const totalIncomePerHour = income + totalClicksPerHour;
  const fetchUserProfilePhoto = useCallback(async (userId) => {
    const response = await fetchWithTimeout(`${process.env.REACT_APP_API_URL}/cards/vsk/${userId}`, {}, 8000);
    if (!response.ok) return null;
    const data = await response.json();
    return data.photoUrl || null;
  }, []);

  useEffect(() => {
    if (!isLoading && !isLoadingData && !isLoadingAva) return undefined;
    const timeout = setTimeout(() => {
      setIsLoadingData(false);
      setIsLoadingAva(false);
      setStartupError((current) => current || 'Загрузка превысила 20 секунд. Попробуйте открыть приложение ещё раз.');
    }, 20000);
    return () => clearTimeout(timeout);
  }, [isLoading, isLoadingData, isLoadingAva]);
  
    const fetchClans = useCallback(async () => {
      if (!user_clan_id) return;
      const response = await fetch(`${process.env.REACT_APP_API_URL}/clans/${user_clan_id}`);
      if (response.ok) {
        const clanData = await response.json();
        setClan(clanData);
  
        // Извлекаем значение тега из полученных данных и сохраняем его
        if (clanData && clanData.tag) {
          setTag(clanData.tag); // Устанавливаем тег
        }
      } else {
        console.error('Ошибка загрузки данных о клане');
        setClan(null);
      }
    }, [user_clan_id]);

  useEffect(() => {
    if (user_clan_id) fetchClans();
  }, [fetchClans, user_clan_id]);


  useEffect(() => {
    const savedSetting = localStorage.getItem('effectsEnabled');
    if (savedSetting !== null) {
      const isEnabled = JSON.parse(savedSetting);
      setEffectsEnabled(isEnabled);
      if (!isEnabled) {
        document.body.classList.add('no-effects');
      }
    }
  }, []);
  useEffect(() => {
    const fetchLeaderboardData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/leaderboard/ref`);
        const data = await response.json();
        setLeaderboardData(data);
      } catch (error) {
        console.error('Ошибка при загрузке данных лидерборда:', error);
      } finally {
      }
    };

    fetchLeaderboardData();
  }, []);

  const refreshEnergy = useCallback(async (targetUsername) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/users/update_Energy`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ username: targetUsername }),
        });

        console.log('Response status:', response.status); // Для отладки

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const data = await response.json();
        setEnergy(data.newEnergy); // Устанавливаем новую энергию из ответа
        console.log(data.message);
    } catch (error) {
        console.error('Error refreshing energy:', error);
    }
}, []);
const fetchAllAchievements = useCallback(async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/achievements`);
    if (!response.ok) throw new Error("Failed to fetch achievements");
    const data = await response.json();
    setAchievements(data);
  } catch (err) {
  }
}, []);

const fetchUserAchievements = useCallback(async (targetUsername) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/achievements/user/${targetUsername}`
    );
    if (!response.ok) throw new Error("Failed to fetch user achievements");
    const data = await response.json();
    setUserAchievements(data.map((a) => a.achievement_id));
  } catch (err) {
  }
}, []);
  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    tg?.ready();
    tg?.expand();
    const user = tg?.initDataUnsafe?.user || (
      process.env.REACT_APP_ENABLE_DEV_AUTH === 'true'
        ? { id: 0, username: process.env.REACT_APP_DEV_USERNAME || 'local_dev' }
        : null
    );
    if (user?.username) {
        setUsername(user.username);
        setUserID(user.id);
        
        // Получение аватара пользователя
        const directTelegramAvatar = user.photo_url || null;
        (directTelegramAvatar ? Promise.resolve(directTelegramAvatar) : fetchUserProfilePhoto(user.id)).then((avatarUrl) => {
          const finalAvatarUrl = avatarUrl || FALLBACK_AVATAR_URL;
          const img = new Image();
          img.src = finalAvatarUrl;
          img.onload = () => {
            console.log("Аватар предзагружен");
            setAvatarUrl(finalAvatarUrl);
            setIsLoadingAva(false); // Снимаем лоадинг после загрузки аватара
          };
          img.onerror = () => {
            console.error("Ошибка загрузки аватара");
            setAvatarUrl(FALLBACK_AVATAR_URL); // Используем резервную аву
            setIsLoadingAva(false); // Снимаем лоадинг
          };
        }).catch((error) => {
          console.error('Ошибка загрузки аватара:', error);
          setAvatarUrl(FALLBACK_AVATAR_URL);
        }).finally(() => setIsLoadingAva(false));

        // Получение данных пользователя
        if (user.username) {
            fetchUserData(user.username);
            fetchAllAchievements();
            fetchUserAchievements(user.username);
            
            // Вызываем refreshEnergy после получения имени пользователя
            refreshEnergy(user.username); // Передаем имя пользователя
        }
    } else {
        console.error('Telegram объект не доступен');
        setStartupError('Откройте кликер кнопкой «Играть» внутри Telegram.');
        setIsLoadingData(false);
        setIsLoadingAva(false);
    }
}, [fetchAllAchievements, fetchUserAchievements, fetchUserData, fetchUserProfilePhoto, refreshEnergy]);

const checkAchievements = useCallback(async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/achievements/check-and-unlock`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({}),
    });

    const data = await response.json();
    if (!response.ok) {
      console.error('Ошибка при проверке ачивок:', data.message);
      return;
    }
    await Promise.all([fetchUserAchievements(username), fetchAllCards()]);
    if (data.achievementUnlocked) {
      triggerToast(`Открыто достижений: ${data.unlockedAchievementIds.length}. Новые карточки уже в магазине!`);
    }
  } catch (error) {
    console.error('Ошибка при отправке данных на сервер для проверки ачивок:', error);
  }
}, [fetchAllCards, fetchUserAchievements, username]);

  useEffect(() => {
    if (currentPage === 'clicker' && username) {
      fetchUserData(username);
      refreshEnergy(username);
    }
  }, [currentPage, fetchUserData, refreshEnergy, username]);

  useEffect(() => {
    if ((currentPage === 'achievements' || currentPage === 'shop') && username) {
      checkAchievements();
    }
  }, [checkAchievements, currentPage, username]);

  const toggleEffects = () => {
    const newState = !effectsEnabled;
    setEffectsEnabled(newState);

    if (newState) {
      document.body.classList.remove('no-effects');
      triggerToast("Эффекты включены");
    } else {
      document.body.classList.add('no-effects');
      triggerToast("Эффекты отключены");
    }

    localStorage.setItem('effectsEnabled', JSON.stringify(newState));
  };

  const triggerToast = (message) => {
    setToastMessage(message);
    setShowToast(true);

    // Скрытие через 3 секунды
    setTimeout(() => setShowToast(false), 3000);
  };


const formatNumber = formatCompactNumber;

useEffect(() => {
  const regenerateEnergy = () => {
    setEnergy(prev => {
      if (prev < maxEnergy) {
        return prev + 1; 
      }
      return prev; 
    });
  };

  const interval = setInterval(regenerateEnergy, 1000); 
  return () => clearInterval(interval); 
}, [maxEnergy, username]); 

const triggerIncomeAnimation = (amount) => {
  const animationContainer = document.getElementById('income-animation');
  const incomeText = document.getElementById('income-text');

  // Income may arrive while StartupScreen is still mounted. The reward is
  // already reflected in React state, so it is safe to skip only the effect.
  if (!animationContainer || !incomeText) return;

  // Устанавливаем текст дохода
  incomeText.textContent = `+${Number(amount).toLocaleString('ru-RU')} кликов`;

  // Показываем анимационный блок
  animationContainer.classList.add('show');

  // Создаем монетки
  for (let i = 0; i < 40; i++) {
    const coin = document.createElement('div');
    coin.className = 'coin';

    // Случайная позиция и скорость для монеток
    coin.style.left = `${Math.random() * 100}vw`;
    coin.style.animationDuration = `${2 + Math.random() * 3}s`;
    coin.style.animationDelay = `${Math.random() * 2}s`;

    // Добавляем монетку в контейнер
    animationContainer.appendChild(coin);

    // Удаляем монетку после завершения анимации
    coin.addEventListener('animationend', () => {
      coin.remove();
    });
  }

  // Убираем контейнер с монетками плавно
  setTimeout(() => {
    animationContainer.classList.remove('show'); // Убираем видимость
    incomeText.textContent = ''; // Очищаем текст дохода

    // Удаляем оставшиеся монетки через дополнительную паузу (если есть)
    setTimeout(() => {
      animationContainer.querySelectorAll('.coin').forEach((coin) => coin.remove());
    }, 1000); // Время совпадает с `transition` в CSS
  }, 5000);
};




const fetchInventory = useCallback(async (userId) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/users/inventory/${userId}`);
    if (!response.ok) throw new Error('Ошибка загрузки инвентаря');

    const data = await response.json();
    setInventory(data);

    // Вычисление суммарного бонуса
    const totalBonus = data.reduce((sum, item) => sum + (item.click_power || 0), 0);
    console.log('Суммарный бонус к клику:', totalBonus);

    setTotalClickBonus(totalBonus); // Занесите эту переменную в состояние для дальнейшего использования
  } catch (error) {
    console.error('Ошибка при загрузке инвентаря:', error);
  }
}, []);

useEffect(() => {
  if (!realuserID) return; // Если realuserID не задан, не делаем запросы
  // Загружаем данные лидерборда
  const fetchLeaderboard = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/leaderboard`);
      const data = await response.json();
      setLeaderboard(data);
    } catch (error) {
      console.error('Error fetching leaderboard:', error);
    }
  };

  // Загружаем данные о рангах
  const fetchRankData = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/leaderboard/ranks`);
      const ranks = await response.json();
      setRankData(ranks);
    } catch (error) {
      console.error('Ошибка получения данных о рангах:', error);
    }
  };

  // Загружаем данные о квестах
  const fetchQuests = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/quests/users/${realuserID}/quests`);
      if (!response.ok) throw new Error('Failed to fetch quests');
      const data = await response.json();
      setAvailableQuests(data.availableQuests);
      setCompletedQuests(data.completedQuests);
    } catch (err) {
    } finally {
    }
  };
      const fetchNotifications = async () => {
        try {
          const user_id = realuserID;
          const response = await fetch(`${process.env.REACT_APP_API_URL}/leaderboard/${user_id}`);
          const data = await response.json();
          setNotifications(data.notifications);
        } catch (error) {
          console.error('Ошибка при загрузке уведомлений:', error);
        } finally {
        }
      };
      
  fetchNotifications();
  fetchQuests();
  fetchLeaderboard();
  fetchRankData();
  fetchInventory(realuserID);
}, [fetchInventory, realuserID]);

useEffect(() => {
  if (currentPage === 'profile' && username && realuserID) {
    fetchUserData(username);
    fetchClans();
    fetchInventory(realuserID);
  }
}, [currentPage, fetchClans, fetchInventory, fetchUserData, realuserID, username]);
 // Добавляем realuserID в зависимости


const getRankDetails = (clickCount, rankData) => {
  const rankName = getRank(clickCount); // Получаем название ранга
  const rankDetails = rankData.find((rank) => rank.name === rankName); // Находим полную инфу
  return rankDetails || null; // Возвращаем объект или null, если не найдено
};
const currentRankDetails = getRankDetails(clickCount, rankData);

  useEffect(() => {
    const fetchUserRefs = async () => {
      if (!username) return;
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/users/refs/${username}`);
        if (!response.ok) throw new Error('Failed to fetch refs');
        const data = await response.json();
        setRefss(data.refs);
      } catch (err) {
        console.error(err);
      }
    };

    const fetchRewards = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/referrals`);
        if (!response.ok) throw new Error('Failed to fetch rewards');
        const data = await response.json();
        setRewards(data);
      } catch (err) {
        console.error(err);
      }
    };

    fetchUserRefs();
    fetchRewards();
  }, [username]);



  if (isLoading || isLoadingData || isLoadingAva || startupError) {
    return <StartupScreen error={startupError} progress={progress} tip={randomTip} />;
  }

  const renderPage = () => {
    switch (currentPage) {
      case 'clicker':
        return (
          <ClickerPage
          TotalClickBonus={TotalClickBonus}
          notifications={notifications}
          setNotifications={setNotifications}
          realuserID={realuserID}
          setRank={setRank}
          fetchUserData={fetchUserData}
          maxClicks={maxClicks}
          setRankProgress={setRankProgress}
            username={username}
            clickCount={clickCount}
            setClickCount={setClickCount}
            clickPower = {clickPower}
            energy={energy}
            setEnergy = {setEnergy}
            maxEnergy={maxEnergy}
            refs = {refs}
            getRank = {getRank}
            income = {income}
            totalClicksPerHour={totalClicksPerHour}
            setCurrentPage={setCurrentPage}
            triggerToast={triggerToast}
            clan_id={user_clan_id}
          />
        );
      case 'leaderboard':
        return <Leaderboard rankData={rankData} leaderboard={leaderboard}/>;
        case 'boss':
          return <Boss clanId={user_clan_id} userId={realuserID} />
        case 'clans':
          return <Clans triggerToast={triggerToast} formatNumber={formatNumber} setSelectedClan={setSelectedClan} setCurrentPage={setCurrentPage}/>;


            case 'clan_add':
          return <ClanCreate triggerToast={triggerToast} setCurrentPage={setCurrentPage} setSelectedClan={setSelectedClan} setUserClanID={setUserClanID} setClan={setClan} setClanTag={setTag} fetchUserData={fetchUserData} username={username}/>;
              case 'clan_list':
                return <ClanList setSelectedClan={setSelectedClan} setCurrentPage={setCurrentPage} formatNumber={formatNumber} triggerToast={triggerToast}/>;
                case 'clans_info':
                  return (
                    <ClanInfo
                    username={username}
                    fetchUserData={fetchUserData}
                    triggerToast={triggerToast}
                    setSelectedClan={setSelectedClan}
                    setCurrentPage={setCurrentPage}
                    userId= {realuserID}
                      clanId={selectedClan}
                      clan={clan}
                    setClan={setClan}
                    setUserClanID={setUserClanID}
                    setClanTag={setTag}
                    onBack={() => setCurrentPage('clan_list')}
                    />
                  );
                      
      case 'friends_sub':
          return <FriendsInv refss={refss} setRewards={setRewards} rewards={rewards} setClickCount={setClickCount} triggerToast={triggerToast}/>;
      case 'quests':
        return <Quests setClickCount={setClickCount} clickCount={clickCount} setAvailableQuests={setAvailableQuests} triggerIncomeAnimation={triggerIncomeAnimation} username={username} realuserID={realuserID} fetchUserData={fetchUserData} triggerToast={triggerToast} availableQuests={availableQuests} completedQuests={completedQuests}/>;
      case 'soon':
          return <Soon refs={refs} username={username} fetchUserData={fetchUserData} realuserID={realuserID} robuxBalance={robux_balance} clickCount={clickCount} triggerToast={triggerToast} robloxusername={robloxusername}/>;

      case 'cards':
        return <Friends triggerToast={triggerToast} setCurrentPage={setCurrentPage} referralCode={referralCode}/>;
      case 'shop':
return (
    <Purchase 
    setCards={setCards}
    cards={cards}
    userID={userID}
    triggerToast={triggerToast}
        username={username}
        energy_charge={energy_charge}
        fetchUserData={fetchUserData}
        clickPower={clickPower}
        clickCount={clickCount}
        setClickCount={setClickCount}
        setClickPower={setClickPower}
        income={income}  
        setIncome={setIncome}
        setEnergy={setEnergy}
        maxEnergy={maxEnergy}  
        setMaxEnergy={setMaxEnergy}
        setEnergyCharge={setEnergyCharge}
        onCardsChanged={fetchAllCards}
    />
);

case 'refbord': {
  return <Refbord leaderboardData={leaderboardData}/>;}
  case 'clan_wars': {
    return <ClanWarsPage triggerToast={triggerToast} setCurrentPage={setCurrentPage} clanId={user_clan_id} userId={realuserID}/>;}
      case 'profile':
        return <ProfilePage inventory={inventory} clan={clan} clan_id={user_clan_id} rank={currentRankDetails} userId={realuserID} setSelectedClan={setSelectedClan} setClan={setClan} triggerToast={triggerToast} username={username} setCurrentPage={setCurrentPage} refs={refs} referralCode={referralCode} fetchUserData={fetchUserData} avatarUrl={avatarUrl} rankProgress={rankProgress} formatNumber={formatNumber} maxClicks={maxClicks} clickCount={clickCount} clickPower={clickPower} income={income} energy={energy} maxEnergy={maxEnergy}/>;
      case 'achievements':
        return <AchievementsPage userAchievements={userAchievements} achievements={achievements} clickCount={clickCount} username={username} />;
      case 'ref':
        return <ReferralPage username={username} setClickCount={setClickCount} triggerToast={triggerToast}/>;
      default:
        return <div className="Main">Страница не найдена</div>;
    }
  };

  return (
    <AppShell
      avatarUrl={avatarUrl}
      username={username}
      clanTag={tag}
      rank={rank}
      rankProgress={rankProgress}
      clickCount={clickCount}
      maxClicks={maxClicks}
      formatNumber={formatNumber}
      incomePerDay={totalIncomePerHour}
      effectsEnabled={effectsEnabled}
      onToggleEffects={toggleEffects}
      onNavigate={setCurrentPage}
      isVideoLoaded={isVideoLoaded}
      toastMessage={toastMessage}
      showToast={showToast}
    >
      {renderPage()}
    </AppShell>
  );
  }
  export default App;
  
